import React from 'react';
import './Form.scss';

interface FormProps {
  data: any;
}

const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const Form: React.FC<FormProps> = ({ data }) => {
  const { quiz, questions } = data;
  const [firstName, setFirstName] = React.useState<string>('');
  const [lastName, setLastName] = React.useState<string>('');
  const [email, setEmail] = React.useState<string>('');
  const [companySize, setCompanySize] = React.useState<string>('');

  const finalAnswers = Object.keys(quiz).map((q, index) => {
    return Object.keys(quiz[q]).map((k) => {
      return questions[index].answers
        .filter((a) => {
          return a.id.toString() === k;
        })
        .map((a) => a.answer)
        .join();
    });
  });

  console.log('finalAnswers', finalAnswers);

  return (
    <div className="form">
      <form
        acceptCharset="UTF-8"
        method="post"
        action="https://go.salesforce-partners.com/l/349921/2020-07-01/4tj2s"
        className="form"
        id="pardot-form"
      >
        <div className="form-field-container  email">
          <p className="form-field pd-text required">
            <input
              type="text"
              name="349921_35839pi_349921_35839"
              id="349921_35839pi_349921_35839"
              value={email}
              className="text"
              placeholder="Your email address"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </p>
        </div>

        <div className="form-field-container  first_name">
          <p className="form-field pd-text required">
            <input
              type="text"
              name="349921_35833pi_349921_35833"
              id="349921_35833pi_349921_35833"
              value={firstName}
              className="text"
              placeholder="First name"
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />
          </p>
        </div>

        <div className="form-field-container last_name">
          <p className="form-field pd-text required">
            <input
              type="text"
              name="349921_35835pi_349921_35835"
              id="349921_35835pi_349921_35835"
              value={lastName}
              className="text"
              placeholder="Last name"
              onChange={(e) => {
                setLastName(e.target.value);
              }}
            />
          </p>
        </div>

        <div className="form-field-container Company_Size">
          <p className="form-field pd-select required">
            <select
              name="349921_35925pi_349921_35925"
              id="349921_35925pi_349921_35925"
              className="select"
              value={companySize}
              onChange={(e) => {
                setCompanySize(e.target.value);
              }}
            >
              <optgroup>
                <option value="">Company size</option>
                <option value="433411">1-20 employees</option>
                <option value="433413">21-100 employees</option>
                <option value="433415">101-500 employees</option>
                <option value="433417">501-3500 employees</option>
                <option value="433419">3501+ employees</option>
              </optgroup>
            </select>
          </p>
        </div>

        <div className="form-field-container  Q_Important_goals_as_you_build_talent_pipeline">
          <p className="form-field pd-hidden  hidden   ">
            <input
              type="hidden"
              name="349921_35927pi_349921_35927"
              id="349921_35927pi_349921_35927"
              value={finalAnswers[3].sort().join('|')}
            />
          </p>
        </div>

        <div className="form-field-container  Q_partnering_with_universities_to_find_talent">
          <p className="form-field pd-hidden  hidden   ">
            <input
              type="hidden"
              name="349921_35929pi_349921_35929"
              id="349921_35929pi_349921_35929"
              value={finalAnswers[1].sort().join('|')}
            />
          </p>
        </div>

        <div className="form-field-container  Q_The_type_of_reskilling_my_team_needs_most_is">
          <p className="form-field pd-hidden  hidden   ">
            <input
              type="hidden"
              name="349921_35931pi_349921_35931"
              id="349921_35931pi_349921_35931"
              value={finalAnswers[2].sort().join('|')}
            />
          </p>
        </div>

        <div className="form-field-container  Q_What_are_your_most_immediate_talent_needs">
          <p className="form-field pd-hidden  hidden   ">
            <input
              type="hidden"
              name="349921_35933pi_349921_35933"
              id="349921_35933pi_349921_35933"
              value={finalAnswers[0].sort().join('|')}
            />
          </p>
        </div>

        <div className="form-field-container  Q_Which_events_are_you_most_interested_in">
          <p className="form-field pd-hidden  hidden   ">
            <input
              type="hidden"
              name="349921_35935pi_349921_35935"
              id="349921_35935pi_349921_35935"
              value={finalAnswers[4].sort().join('|')}
            />
          </p>
        </div>

        <p className="submit">
          <input
            type="submit"
            value="Submit"
            disabled={
              !(
                email.length > 0 &&
                validateEmail(email) &&
                firstName.length > 2 &&
                lastName.length > 2 &&
                companySize !== ''
              )
            }
          />
        </p>
      </form>
    </div>
  );
};

export default Form;
